import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from '@mui/material';

export default function MessagePopup(props) {
  const { data, handleClose, alertTitle, alertContent, successBtnName } = props;
  return (
    <Dialog
      open={data}
      onClose={() => {
        handleClose();
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      BackdropProps={{ style: { zIndex: 2050 } }}
      PaperProps={{ style: { zIndex: 2100 } }}
    >
      <DialogTitle id="alert-dialog-title">{alertTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{alertContent}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleClose();
          }}
          color="primary"
          autoFocus
        >
          {successBtnName || 'Okay'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
